var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_6966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_6966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_6966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9793 -13.9854C26.7034 -14.2466 27.4742 -13.6509 27.404 -12.8844C26.8154 -6.45553 27.1456 2.33195 23.2787 7.336C19.4118 12.3401 10.8253 14.2369 4.75289 16.428C4.0288 16.6892 3.25796 16.0936 3.32816 15.327C3.91681 8.89814 3.58665 0.110656 7.45354 -4.89339C11.3204 -9.89745 19.9069 -11.7943 25.9793 -13.9854Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4797 29.6509C13.8988 30.6728 15.0752 31.172 16.0368 30.6287C17.2791 29.9268 18.4246 29.0604 19.4412 28.0507C20.932 26.57 22.1166 24.8103 22.9273 22.8718C23.738 20.9334 24.159 18.8543 24.1661 16.7531C24.171 15.3203 23.9835 13.8964 23.6108 12.519C23.3222 11.4528 22.1408 10.9659 21.1188 11.3851L10.0168 15.9394C8.99488 16.3586 8.50628 17.5268 8.92548 18.5488L13.4797 29.6509Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8632 10.0504C7.9846 10.7198 7.80521 11.9899 8.61111 12.7452C10.4194 14.4401 12.722 15.5455 15.2104 15.8818C18.3643 16.308 21.5584 15.4639 24.0899 13.5351C26.6214 11.6063 28.2831 8.75094 28.7093 5.59704C29.0455 3.10861 28.591 0.595197 27.4369 -1.59808C26.9225 -2.57557 25.6503 -2.73974 24.7717 -2.07033L16.8175 3.99001L8.8632 10.0504Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.051 -1.53714C12.3888 -1.97414 12.3103 -2.60609 11.8467 -2.90625C10.1442 -4.00858 8.18494 -4.66446 6.15071 -4.8048C3.78299 -4.96814 1.42 -4.42569 -0.639439 -3.24605C-2.69887 -2.06641 -4.36226 -0.302555 -5.41925 1.82246C-6.47624 3.94747 -6.87935 6.33819 -6.57763 8.69232C-6.2759 11.0464 -5.28287 13.2582 -3.72413 15.048C-2.16539 16.8377 -0.110932 18.1251 2.17944 18.7472C4.4698 19.3693 6.89322 19.2983 9.14322 18.5431C11.0763 17.8943 12.8068 16.7655 14.1763 15.2694C14.5492 14.862 14.4657 14.2307 14.0287 13.893L6.11615 7.77824C5.67915 7.44054 5.59866 6.81251 5.93637 6.3755L12.051 -1.53714Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 6.19518C17.3726 6.05677 17.9432 6.62735 17.8048 7.24979C16.6442 12.4697 15.99 19.7242 12.2861 23.4283C8.58209 27.1324 1.32772 27.7866 -3.89208 28.9473C-4.5145 29.0857 -5.08508 28.5152 -4.94669 27.8927C-3.78606 22.6728 -3.13195 15.4183 0.572025 11.7142C4.276 8.01014 11.5304 7.3559 16.7502 6.19518Z",
    fill: "#E2BBDB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_6966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg2);
export default __webpack_public_path__ + "static/media/profileImg2.273289437bd32b1975d93f5d06a1f83f.svg";
export { ForwardRef as ReactComponent };